import { Component, EventEmitter, OnInit, Output, inject } from '@angular/core';
import { FormBuilder, Validators, ReactiveFormsModule } from '@angular/forms';
import {
  ErrorComponent,
  InputWithErrorComponent,
  SaveableFormComponent,
  Worker,
  Workflow,
  WorkflowService,
} from '@nimmsta/ng-commons-lib';
import { WorkerService } from '../../services/worker.service';
import { TranslatePipe } from '@ngx-translate/core';

@Component({
  selector: 'app-worker-form',
  templateUrl: './worker-form.component.html',
  imports: [
    ReactiveFormsModule,
    TranslatePipe,
    InputWithErrorComponent,
    ErrorComponent,
  ],
})
export class WorkerFormComponent
  extends SaveableFormComponent<Worker>
  implements OnInit
{
  private fb = inject(FormBuilder);
  private workflowService = inject(WorkflowService);

  protected override dataService = inject(WorkerService);

  @Output() override closeEvent = new EventEmitter();

  @Output() override loadingEvent = new EventEmitter<boolean>();

  workflows: Workflow[] = [];

  get workflowIds() {
    return this.workflows
      .filter((workflow) => !workflow.isIdle)
      .map((workflow) => workflow.id);
  }

  get workflowNames() {
    return this.workflows
      .filter((workflow) => !workflow.isIdle)
      .map((workflow) => workflow.name);
  }

  get idleWorkflowIdsWithEmpty() {
    return this.workflows
      .filter((workflow) => workflow.isIdle)
      .map((workflow) => workflow.id);
  }

  get idleWorkflowNamesWithEmpty() {
    return this.workflows
      .filter((workflow) => workflow.isIdle)
      .map((workflow) => workflow.name);
  }

  constructor() {
    super();
    this.setValue({} as Worker);
  }

  ngOnInit(): void {
    this.workflowService.simpleList().subscribe((workflows) => {
      this.workflows = workflows;
    });
  }

  protected setFormGroup(): void {
    if (!this.value.assignedWorkflowId && this.workflowIds.length === 1) {
      this.value.assignedWorkflowId = this.workflowIds[0];
    }
    this.form = this.fb.group({
      id: this.value.id,
      email: [this.value.email, [Validators.email]],
      given_name: [
        this.value.given_name,
        [
          Validators.required,
          Validators.minLength(2),
          Validators.maxLength(30),
        ],
      ],
      family_name: [
        this.value.family_name,
        [
          Validators.required,
          Validators.minLength(2),
          Validators.maxLength(30),
        ],
      ],
      assignedWorkflowId: [
        this.value.assignedWorkflowId,
        [Validators.required],
      ],
      assignedIdleWorkflowId: this.value.assignedIdleWorkflowId,
      additionalData: this.value.additionalData,
      usesDraftWorkflowDefinition: this.value.usesDraftWorkflowDefinition,
      shouldUpdateDeviceOrganization:
        this.value.shouldUpdateDeviceOrganization || false,
    });
  }
}
